export const GENERAL_SETTINGS_TARGET_IDS = {
  model: "settings-general-model",
  channels: "settings-general-channels",
  security: "settings-general-security",
  system: "settings-general-system",
  appearance: "settings-general-appearance",
  personal: "settings-general-personal",
  automations: "settings-general-automations",
} as const;

export const APPEARANCE_SETTINGS_TARGET_IDS = {
  theme: "settings-appearance-theme",
  textSize: "settings-appearance-text-size",
  chat: "settings-appearance-chat",
  connection: "settings-appearance-connection",
} as const;

export const COMMUNICATION_SETTINGS_TARGET_IDS = {
  notifications: "settings-communications-notifications",
} as const;
